export default __webpack_public_path__ + "static/media/api-key.092da0d5.svg";